import { Injectable, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService{

  constructor() {
    // console.log('ThemeService initialized');
    this.loadTheme();
  }

  loadTheme(): void {
    // Quando implementar o darkmode
    // const prefersDarkMatches = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    if (environment.app === 'evotrilha'){
      document.body.classList.add('evotrilha');
    }else{
      document.body.classList.add('trilhaedu');
    }

  }

  // applyTheme(isDarkMode: boolean) {
  //   if (isDarkMode) {
  //     this.renderer.addClass(document.body, 'dark');
  //   } else {
  //     this.renderer.removeClass(document.body, 'dark');
  //   }
  // }

}
